import { render, staticRenderFns } from "./cpts-accueil.vue?vue&type=template&id=96ff8d42&scoped=true&"
import script from "./cpts-accueil.vue?vue&type=script&lang=js&"
export * from "./cpts-accueil.vue?vue&type=script&lang=js&"
import style0 from "./cpts-accueil.vue?vue&type=style&index=0&id=96ff8d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff8d42",
  null
  
)

export default component.exports